import TableActionMenu from './TableActionMenu.vue';

export default TableActionMenu;
